export const EARNINGS_RECALCULATION_INTERVAL_MS = 5000
export const TICK_ANIMATION_LENGTH_MS = 3000
